import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper, Typography } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(3),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        marginTop: '0%',
        marginBottom: '3.2%',
        display: 'flex',
        flexDirection: 'column',
        marginLeft:'10%'
    },
}));

export default function ListResultados({ rows, isLoadUser, nameBascula, idBasula, primaryColor, busqueda, handleAñadirOximetria }) {
    const classes = useStyles();
   
    return (
        <>
            {isLoadUser ? (
                <></>
            ) : (
                <Paper className={classes.card}>
                    {rows.map((row, index) => (
                    <Grid container xs={12}>
                        <Typography style={{ width: '50%', fontWeight: 'bold', fontSize: '17px',marginBottom:'3%' }}>
                            {row.question || '--'}
                        </Typography>
                        <Typography style={{ width: '48%', fontWeight: 'bold', fontSize: '17px', paddingRight: '2%',marginBottom:'3%',marginLeft:'2%' }}>
                            {row.answer || '--'}
                        </Typography>
                    </Grid>
                     ))}
                </Paper>
            )}
        </>
    );
}